import {Component, Input} from '@angular/core';
import {IconifyComponent} from "../../../../../shared/standalone-components/iconography/iconify/iconify.component";
import {NgClass} from '@angular/common';

@Component({
  selector: 'bor-about-section',
  imports: [
    IconifyComponent,
    NgClass
  ],
  templateUrl: './about-section.component.html',
  styleUrl: './about-section.component.scss',
  host: { class: 'home-sections' }
})
export class AboutSectionComponent {
  @Input() isPage = false;
}
